<template>
  <div
    class="tasklist-row-hover-actions"
    :class="{ 'tasklist-row-hover-actions--hidden': isSelected }"
    data-testid="tasklist__row-hover-actions"
  >
    <div class="tasklist-row-hover-actions__bar">
      <template v-for="actionId in inlineActions">
        <v-tooltip
          :key="actionId"
          top
          content-class="tooltip-top"
        >
          <template v-slot:activator="{ on, attrs }">
            <button
              type="button"
              class="tasklist-row-hover-actions__btn"
              v-bind="attrs"
              v-on="on"
              :aria-label="getActionMeta(actionId).label"
              :data-testid="`tasklist__row-hover-action-${actionId}`"
              @click.stop="$emit('action', { actionId, task })"
            >
              <img
                v-if="getActionMeta(actionId).iconType === 'img'"
                :src="getActionMeta(actionId).iconSrc"
                :alt="getActionMeta(actionId).iconAlt || getActionMeta(actionId).label"
                class="tasklist-row-hover-actions__icon-img"
              />
              <v-icon
                v-else
                small
                class="tasklist-row-hover-actions__icon"
              >
                {{ getActionMeta(actionId).icon }}
              </v-icon>
            </button>
          </template>
          <span>{{ getActionMeta(actionId).label }}</span>
        </v-tooltip>
      </template>

      <span
        v-if="showMore && inlineActions.length"
        class="tasklist-row-hover-actions__divider"
        aria-hidden="true"
      />

      <slot v-if="showMore" name="more" />
    </div>
  </div>
</template>

<script>
import {
  ROW_HOVER_ACTION_IDS,
  ROW_HOVER_ACTION_META,
} from '../../../../../utils/tasklistHelpers';

export default {
  name: 'TaskRowHoverActions',
  props: {
    task: { type: Object, default: () => ({}) },
    actions: { type: Array, default: () => [] },
    isSelected: { type: Boolean, default: false },
  },
  computed: {
    inlineActions() {
      return this.actions.filter((id) => id !== ROW_HOVER_ACTION_IDS.MORE);
    },
    showMore() {
      return this.actions.includes(ROW_HOVER_ACTION_IDS.MORE);
    },
  },
methods: {
    getActionMeta(actionId) {
      return ROW_HOVER_ACTION_META[actionId] || { label: actionId, iconType: 'mdi', icon: 'mdi-dots-horizontal' };
    },
  },
};
</script>

<style lang="scss" scoped>
@import './TaskRowHoverActions.scss';
</style>
